module.exports = __webpack_public_path__ + "static/media/pie-chart.48f30970.svg";